export default {
  tool: {
    playable: {
      template: '可玩模板换肤项目',
      editor: '可玩自由编辑项目',
    },
    video: {
      editor: '视频项目',
    },
    screen: {
      recording: '录屏项目',
    },
    customized: {
      creative: '创意服务',
    },
  },
}
